module.exports = __webpack_public_path__ + "img/chat-w-ada.97ad3b38.jpg";